import React from "react";
import { useTranslation } from "react-i18next";

const BULLETS = [
  "exp.trader.b1",
  "exp.trader.b2",
  "exp.trader.b3",
  "exp.trader.b4",
];

function TraderDesigned() {
  const { t } = useTranslation();

  return (
    <section className="mt">
      <div className="glcontainer flex flex-col xl:flex-row xl:items-start gap-[40px] xl:gap-[103px]">
        {/* Left */}
        <div className="xl:w-[517px] xl:shrink-0 flex flex-col gap-[40px]">
          <h2 className="font-['Montserrat'] font-black text-[24px] xl:text-[46px] text-[#0a0a0a] tracking-[-0.92px] uppercase leading-none">
            {t("exp.trader.title")}
          </h2>
          <p className="font-['Inter'] font-normal text-[14px] xl:text-[18px] text-[#717171] leading-[1.4]">
            {t("exp.trader.desc")}
          </p>
        </div>

        {/* Right: bullet list */}
        <div className="flex flex-col flex-1 xl:pt-[6px]">
          {BULLETS.map((key, i) => (
            <div key={i}>
              <div className="flex items-center gap-[20px] xl:gap-[20px] px-0 xl:px-[60px] py-[16px] xl:py-[20px]">
                <div className="bg-[#f04e0a] rounded-[7px] size-[14px] shrink-0" />
                <span className="font-['Montserrat'] font-semibold text-[16px] xl:text-[20px] text-[#020202] leading-normal">
                  {t(key)}
                </span>
              </div>
              {i < BULLETS.length - 1 && <div className="h-[1px] bg-[#ebebeb]" />}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TraderDesigned;
